export default "dist/images/block-team-member-overlay.9135997.png";